export default __webpack_public_path__ + "83d09a5ee199124ed08566aaee5ddc2c.png";